(function () {
  'use strict';

  var form = document.querySelector('[data-contact-form]');
  if (!form) return;

  var nameField = form.querySelector('[data-contact-name]');
  var emailField = form.querySelector('[data-contact-email]');
  var phoneField = form.querySelector('[data-contact-phone]');
  var messageField = form.querySelector('[data-contact-message]');
  var bodyField = form.querySelector('[data-contact-body-field]');
  var errorsEl = form.querySelector('[data-contact-errors]');

  function showErrors(messages) {
    if (!errorsEl) return;
    if (!messages.length) {
      errorsEl.hidden = true;
      errorsEl.innerHTML = '';
      return;
    }
    errorsEl.hidden = false;
    var list = document.createElement('ul');
    list.className = 'contact-form__errors-list';
    messages.forEach(function (msg) {
      var li = document.createElement('li');
      li.textContent = msg;
      list.appendChild(li);
    });
    errorsEl.innerHTML = '';
    errorsEl.appendChild(list);
    errorsEl.focus();
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function validate() {
    var errors = [];
    var name = nameField ? nameField.value.trim() : '';
    var email = emailField ? emailField.value.trim() : '';
    var message = messageField ? messageField.value.trim() : '';

    if (!name) {
      errors.push(form.getAttribute('data-error-name') || 'Ange ditt fullständiga namn.');
      if (nameField) nameField.setAttribute('aria-invalid', 'true');
    } else if (nameField) {
      nameField.removeAttribute('aria-invalid');
    }

    if (!email) {
      errors.push(form.getAttribute('data-error-email') || 'Ange din e-postadress.');
      if (emailField) emailField.setAttribute('aria-invalid', 'true');
    } else if (!isValidEmail(email)) {
      errors.push(form.getAttribute('data-error-email-invalid') || 'Ange en giltig e-postadress.');
      if (emailField) emailField.setAttribute('aria-invalid', 'true');
    } else if (emailField) {
      emailField.removeAttribute('aria-invalid');
    }

    if (!message) {
      errors.push(form.getAttribute('data-error-message') || 'Skriv ett meddelande.');
      if (messageField) messageField.setAttribute('aria-invalid', 'true');
    } else if (messageField) {
      messageField.removeAttribute('aria-invalid');
    }

    showErrors(errors);
    return errors.length === 0;
  }

  function buildBody() {
    var phone = phoneField && phoneField.value.trim() ? phoneField.value.trim() : '—';
    var message = messageField && messageField.value.trim() ? messageField.value.trim() : '—';
    return [
      '--- Kontaktformulär ---',
      'Telefon: ' + phone,
      '---',
      message,
    ].join('\n');
  }

  form.addEventListener('submit', function (e) {
    if (!validate()) {
      e.preventDefault();
      var firstInvalid = form.querySelector('[aria-invalid="true"]');
      if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
      return;
    }

    if (bodyField) bodyField.value = buildBody();
  });

  [nameField, emailField, phoneField, messageField].forEach(function (field) {
    if (!field) return;
    field.addEventListener('input', function () {
      field.removeAttribute('aria-invalid');
      if (errorsEl && !errorsEl.hidden) {
        validate();
        if (errorsEl.querySelectorAll('li').length === 0) showErrors([]);
      }
    });
  });
})();
